import Alert from 'components/ui/Alert';
import { useTranslation } from 'hooks/useTranslation';

const LeadNotFound = (): JSX.Element => {
  const { t } = useTranslation(true);

  return (
    <div className="max-w-screen-md mx-auto px-5 md:px-4 mb-8 py-6">
      <div className="p-12 text-center mx-auto">
        <Alert type="error">
          <p className="font-bold">{t('noLeadFound')}</p>
          <p>
            {t('noLeadFound.outdatedOrIncorrect')}
            <br />
            {t('noLeadFound.pleaseContactUs')}
          </p>
        </Alert>
      </div>
    </div>
  );
};

export default LeadNotFound;
